export const cdnUrl = (path: string): string =>
  `${import.meta.env.VITE_CDN_URL}/${path}`;
